import React, { Component } from 'react';
import ShippingAddressForm from './components/shipping-address-form';
import featureImage from './img/shipping-address-feature.png';
import './index.css';

export default class ShippingAddressPage extends Component {
  render() {
    return (
      <div className="shipping-address-page">
        <div className="image-frame">
          <img src={ featureImage } alt="Workout" />
        </div>
        <p><strong>Yay! Your membership is now active.</strong></p>
        <p>Enter in your shipping information below to receive a free wearable.</p>
        <ShippingAddressForm />
      </div>
    );
  }
}
